//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DynamoPageLocation {
	Page = 0,
	Today = 1,
	Tabber = 2,
	Portal = 3
}
